module.exports = __webpack_public_path__ + "img/file_pdf.5e23781b.png";